// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationAuthenticateUserDefaultResponse {
    static getAttributeTypeMap() {
        return AuthenticationAuthenticateUserDefaultResponse.attributeTypeMap;
    }
}
AuthenticationAuthenticateUserDefaultResponse.discriminator = undefined;
AuthenticationAuthenticateUserDefaultResponse.additionalProperties = false;
AuthenticationAuthenticateUserDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Extauth2ValidateStatus"
    },
];
//# sourceMappingURL=authenticationAuthenticateUserDefaultResponse.js.map